/* ---------------------------------------------------------------------------------------------
 * Copyright (c) Infiniscene, Inc. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * -------------------------------------------------------------------------------------------- */
export const overlays = [
  {
    id: '123',
    url: 'https://www.pngmart.com/files/12/Twitch-Stream-Overlay-PNG-Transparent-Picture.png',
    thumbnail:
      'https://www.pngmart.com/files/12/Twitch-Stream-Overlay-PNG-Transparent-Picture.png',
  },
  {
    id: '124',
    url: 'https://www.pngmart.com/files/12/Stream-Overlay-Transparent-PNG.png',
    thumbnail:
      'https://www.pngmart.com/files/12/Stream-Overlay-Transparent-PNG.png',
  },
  {
    id: '125',
    url: 'https://www.pngmart.com/files/12/Stream-Overlay-Transparent-PNG.png',
    thumbnail:
      'https://www.pngmart.com/files/12/Stream-Overlay-Transparent-PNG.png',
  },
]

  export const videooverlays = [
    {
      id: '125',
      url: 'https://assets.mixkit.co/videos/preview/mixkit-stars-in-space-1610-large.mp4',
      thumbnail:
        'https://i.ibb.co/Zd0RfMM/Screenshot-from-2023-03-13-22-41-14.png',
    },
    {
      id: '126',
      url: 'https://assets.mixkit.co/videos/preview/mixkit-curvy-road-on-a-tree-covered-hill-41537-large.mp4',
      thumbnail:
        'https://i.ibb.co/YR4fdLt/Screenshot-from-2023-03-13-22-42-57.png',
    },
    {
      id: '127',
      url: 'https://assets.mixkit.co/videos/preview/mixkit-curvy-road-on-a-tree-covered-hill-41537-large.mp4',
      thumbnail:
        'https://i.ibb.co/YR4fdLt/Screenshot-from-2023-03-13-22-42-57.png',
    },
  ]

    export const backgrounds = [
      {
        id: '125',
        url: 'https://assets.mixkit.co/videos/preview/mixkit-stars-in-space-1610-large.mp4',
        thumbnail:
          'https://i.ibb.co/Zd0RfMM/Screenshot-from-2023-03-13-22-41-14.png',
      },
      {
        id: '126',
        url: 'https://assets.mixkit.co/videos/preview/mixkit-curvy-road-on-a-tree-covered-hill-41537-large.mp4',
        thumbnail:
          'https://i.ibb.co/YR4fdLt/Screenshot-from-2023-03-13-22-42-57.png',
      },
      {
        id: '127',
        url: 'https://www.pngmart.com/files/12/Stream-Overlay-Transparent-PNG.png',
        thumbnail:
          'https://www.pngmart.com/files/12/Stream-Overlay-Transparent-PNG.png',
      },
    ]

     export const logos = [
        {
          id: '128',
          url: 'https://www.pngmart.com/files/12/Twitch-Stream-Overlay-PNG-Transparent-Picture.png',
          thumbnail:
            'https://www.pngmart.com/files/12/Twitch-Stream-Overlay-PNG-Transparent-Picture.png',
        },
        {
          id: '129',
          url: 'https://www.pngmart.com/files/12/Stream-Overlay-Transparent-PNG.png',
          thumbnail:
            'https://www.pngmart.com/files/12/Stream-Overlay-Transparent-PNG.png',
        },
      ]